require("./_config");

global.jQuery = require("jquery");
global.$ = jQuery;

const $ = require("../../node_modules/jquery/dist/jquery.min");
const asidemenu = require("./_asidemenu");
const slideshow = require("./_slideshow");
const menu = require("./_menu");
const notice = require("./_notice");
const popup = require("./_popup");
const overlay = require("./_overlay");
const accordion = require("./_accordion");
const scrollbutton = require("./_scrollbutton");
const loginmenu = require("./_loginmenu");
const header = require("./_header");
const chosen = require("./_chosen");

$(() => {
  asidemenu.init();
  slideshow.init();
  menu.init();
  notice.init();
  popup.init();
  overlay.init();
  accordion.init();
  scrollbutton.init();
  loginmenu.init();
  header.init();
  chosen.init();
});
